import elementResizeDetectorMaker from 'element-resize-detector';
// import global from '../../../../common/global';
export default {
    data: function() {
        return {
            showNavList: [], //  can be displayed normally in the navigation bar nav
            hideNavList: [], //  show on  drop down middle nav
            showDropDown: false //  show  drop down
        };
    },
    mounted() {
        this.navLength = 0; // slave nav length 
        this.offsetLeft = 0; // slave nav  left   Distance from the left side of the screen 
        this.children = [];
        this.erd = elementResizeDetectorMaker();
        this.erd.listenTo(this.$refs['navContainer'], ele => {
            this.handleNavResize(ele);
        });
        //  Since fonts etc are loaded dynamically ， so need to monitor slave nav length ， Dynamic change 
        this.erd.listenTo(this.$refs['slaveNav'], ele => {
            const { width, left } = ele.getBoundingClientRect();
            this.navLength = width;
            this.offsetLeft = left;
            this.children = [...ele.children].slice(1); //  exclude object， Depend on elementResizeDetectorMaker insert 
            this.handleNavResize(this.$refs['navContainer']);
        });
    },
    beforeUnmount() {
        this.erd.removeListener(
            this.$refs['navContainer'],
            this.handleNavResize
        );
    },
    methods: {
        //  Callback when the size of the navigation bar container changes 
        handleNavResize(ele) {
            const { width } = ele.getBoundingClientRect();
            if (this.navLength <= width) {
                this.sliceData(this.listingStatus.length, false);
            } else {
                this.calcVisibleCount(width);
            }
        },
        //  Calculate how many elements can be displayed in the navigation bar 
        calcVisibleCount(width) {
            this.offsetLeft =
                this.$refs['slaveNav'] &&
                this.$refs['slaveNav'].getBoundingClientRect().left;
            for (
                let index = 0, len = this.children.length;
                index < len;
                index++
            ) {
                const child = this.children[index];
                const { right } = child.getBoundingClientRect();
                // 88 = marginRight + moreWidth
                let reservedPosition =
                    index === this.listingStatus.length - 1 ? 0 : 88;
                //  Can't show anymore 
                if (right - this.offsetLeft > width - reservedPosition) {
                    // index  Give drop down Reserve a place for the display of 
                    return this.sliceData(index, true);
                }
                this.sliceData(this.listingStatus.length, false);
            }
        },
        // nav data distribution 
        sliceData(index, showDropDown) {
            this.showNavList = [...this.listingStatus.slice(0, index)];
            this.hideNavList = [...this.listingStatus.slice(index)];
            this.showDropDown = showDropDown;
        }
    }
};
